import {Dictionary} from '../../../../../libs/shared/helpers/src/typescript/typeHelpers';
import {
  AnalyticsTableMetricColumn,
  AnalyticsTableMetricRow,
  isNumericDataPoint,
} from '../../../../models/api/analyticsMetricsModel';

// Map table columns with other columns indicating the number of events for the metric.
const COLUMNS_WITH_MIN_EVENTS: Dictionary<string> = {
  average_reply_time: 'reply_count',
  average_first_reply_time: 'first_reply_count',
  average_handle_time: 'handle_time_count',
};

// To avoid outliers, we don't show variations for time-related metrics unless there is enough events.
const MIN_EVENTS = 5;

export const topListsFilter = (
  row: AnalyticsTableMetricRow,
  columns: ReadonlyArray<AnalyticsTableMetricColumn>,
  valueAccessor: string,
) => {
  if (!Object.keys(COLUMNS_WITH_MIN_EVENTS).includes(valueAccessor)) {
    return true;
  }

  const minEventsColumnAccessor = COLUMNS_WITH_MIN_EVENTS[valueAccessor];
  const minEventsColumnIndex = columns.findIndex((c) => c.id === minEventsColumnAccessor);
  const minEventValue = row[minEventsColumnIndex];

  // Should not happen.
  if (!minEventValue) {
    return false;
  }

  if (!isNumericDataPoint(minEventValue)) {
    return true;
  }

  return minEventValue.value >= MIN_EVENTS && minEventValue.previousValue >= MIN_EVENTS;
};
